import { Button, Stack, Typography } from '@mui/material'

import { StaticMultiSelect } from '@common/components/Selects'
import { useSmallScreen } from '@common/utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {boolean} props.disabled
 * @param {Object[]} props.availableProperties
 * @param {Object[]} props.selectedProperties
 * @param {Function} props.setSelectedProperties
 * @param {boolean} props.enableGrouping
 * @param {Function} props.setSelectedGrouping
 * @param {Function} props.fetchMetrics
 */
export default function PropertySelector({
  disabled,
  availableProperties,
  selectedProperties,
  setSelectedProperties,
  enableGrouping,
  setSelectedGrouping,
  fetchMetrics,
}) {
  const isSmallScreen = useSmallScreen()

  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="body1">Properties</Typography>
      <StaticMultiSelect
        required
        data-testid="property_selector"
        dynamicWidth={isSmallScreen.mobile}
        options={availableProperties}
        size="small"
        value={selectedProperties}
        onChange={setSelectedProperties}
        onSave={(properties) => {
          fetchMetrics({ properties })
        }}
        limitTags={1}
        groupBy={enableGrouping ? (option) => option.expandedGroupName : null}
        sortByFields={enableGrouping ? ['expandedGroupName', 'name'] : null}
        disabled={disabled}
        renderGroup={(params) => (
          <li key={params.key}>
            <Typography
              variant="h6"
              sx={{
                px: 2,
                py: 1,
                display: 'flex',
                '&:hover > button': { visibility: 'visible' },
                backgroundColor: 'primary.main',
                color: 'white',
              }}
            >
              {params.group}
              <Button
                variant="text"
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  setSelectedProperties(
                    availableProperties.filter(
                      (p) => p.expandedGroupName === params.group,
                    ),
                  )
                  setSelectedGrouping('property')
                }}
                sx={{ marginLeft: 'auto', visibility: 'hidden', color: 'white' }}
              >
                only
              </Button>
            </Typography>
            <ul style={{ padding: 0 }}>{params.children}</ul>
          </li>
        )}
        onlyButton={availableProperties?.length > 1}
        onlyButtonCallback={() => {
          setSelectedGrouping('property')
        }}
      />
    </Stack>
  )
}
